import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Button,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  Table,
  makeStyles,
} from "@material-ui/core";
import MigaPan from "../../app/orussystem/component/MigaPan";
import ModalUsers from "./Component/ModalUsers";
import { assignEvbi, getUsuarios, updateStatusUser } from "../domain/api/UsersApi";
import ListUsersGeneral from "./Component/ListUsers"
import { panelUsersAuthStyle } from "../users_auth/panelUsersAuthStyle";
import { Store } from "react-notifications-component";
import { ModalTowButton } from "../../utils/modals/modalInfoTowButton";
import { useDispatch } from "react-redux";
import { ModalChangeRol } from "../users_auth/components/modals/modalChangeRol";
import { ModalHandledMachine } from "../users_auth/components/modals/modalHandledMachine";
import { getClientes } from "../domain/api/ClientesApi";
import theme from "../../app/config/themaConfig";

export const PanelUsers = () => {
  const clases = panelUsersAuthStyle()
  const [isOpenModal, setisOpenModal] = useState(false)
  const [isEdit, setisEdit] = useState(false)
  const [dataEdit, setdataEdit] = useState([])
  const [listDate, setlistDate] = useState([])
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [busqueda, setBusqueda] = useState("")
  const [totalElements, setTotalElements] = useState("")
  const [listClientes, setListClientes] = useState([])


  const dispatch = useDispatch();
  const [isOpenModalRol, setisOpenModalRol] = useState(false)
  const [dateChangeRol, setdateChangeRol] = useState("")
  const [isOpenModalChange, setisOpenModalChange] = useState(false)
  const [isOpenModalMachine, setisOpenModalMachine] = useState(false)
  const [id_change_bascula, setid_change_bascula] = useState("")



  const [isOpenModalChangeStatus, setisOpenModalChangeStatus] = useState(false)
  const [stateUser, setstateUser] = useState("")
  const [selectMachine, setselectMachine] = useState([])
  const [selectCliente, setSelectCliente] = useState([])

  const useStyles = makeStyles((theme) => ({
    title: {
      marginBottom: '30px',
      marginTop: '30px',
      fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
    },
    TableCell: {
      color: '#0088FE',
      fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
      fontWeight: 'bold',
      fontSize: '17px',

    },
    title: {
      marginBottom: '30px',
      marginTop: '30px',
      fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
      marginLeft: '10%'
    },
    box: {
      marginLeft: '1%',
      marginTop: '3%',
      marginBottom: '3%'
    }, searchContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end', // Alinea al final (derecha)
      paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
    },
    searchInputContainer: {
      display: 'flex',
      borderRadius: '20px 0px 0px 20px',
      height: '32px',
      fontSize: '16px',
    },
    searchInput: {
      border: '1px solid  #b6b7b7',
      borderRadius: '20px 0px 0px 20px',
      padding: '4px 8px',
      height: '100%',
      fontSize: 'inherit',
      outline: 'none',
      flex: 1,
    },
    searchButton: {
      background: '#0088FE',
      color: 'white',
      borderRadius: '0px 50px 50px 0px',
      padding: '8px 16px',
      fontSize: '14px',
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      width: '100%'
    },
  }));


  // Function to handled machine
  const handleChangeBasculas = (lista) => {
    setselectMachine(lista);
  };
  const handleselectCliente = (event) => {
    setSelectCliente(event.target.value);
  };
  const handledOpenEditModal = (data) => {
    setdataEdit(data)
    setisEdit(true)
    setisOpenModal(true)
  }
  const handledOpenModal = () => {
    setdataEdit([])
    setisEdit(false)
    setisOpenModal(true)
  }
  const handledAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true
      }
    });
    setTimeout(() => {
      init()
    }, 1000);
  }
  const init = async () => {

    setLoading(false)
    //lista de clientes
    const users = await getUsuarios();
    const clientes = await getClientes(dispatch, "", 0, 30)

    try {

      setlistDate(users.respuesta)
      setTotalElements(users.totalElements)
      setListClientes(clientes.content)


      setLoading(false)
    } catch {
      setlistDate([])
      setLoading(false)
    }

  }


  const handledOpenModalState = (data) => {
    setstateUser(data)
    setisOpenModalChangeStatus(true)
  }
  const OpenModalInfoChangeRol = (date) => {
    setisOpenModalChange(true)
    setdateChangeRol(date)
  }


  const changeStatus = async () => {
    const response = await updateStatusUser(dispatch, stateUser.id)

    try {

      if (response) {
        handledAlert("Actualizado Exitosamente!", `usuario ${stateUser.name} actualizado con exito!`, "success")
        setisOpenModalChangeStatus(false)
      } else {
        handledAlert("Ocurrio un erro!", "Ocurrio un error al cambiar el estado", "danger")
      }

    } catch {
      handledAlert("Ocurrio un erro!", "Error interno", "danger")
    }
  }


  useEffect(() => {
    init(); // Llamada inicial a fetchUsers al montar el componente
  }, []);



  const openModalRol = () => {
    setisOpenModalChange(false)
    setisOpenModalRol(true)
  }
  const openModalMachine = (row) => {
    setstateUser(row)
    setid_change_bascula(row.id)
    setisOpenModalMachine(true)
  }
  const clickAcept = async () => {
    const rol = stateUser.roles[0].name;

    if (rol === 'ROLE_CLIENT') {

      let list = selectMachine;


      let Request =
      {
        evbis: list,
        cliente: selectCliente,
        usuario: stateUser.id
      }

      const response = await assignEvbi(dispatch, Request)
      try {

        if (response.codigo === '0000') {
          handledAlert("Actualizado Exitosamente!", `Estaciones asignadas con exito para el usuario ${stateUser.name}!`, "success")
          setisOpenModalMachine(false)
        } else {
          handledAlert("Ocurrio un error!", "Ocurrio un error al Asignar las  evbis intente nuevamente", "danger")
        } setisOpenModalMachine(false)

      } catch {
        handledAlert("Ocurrio un erro!", "Error interno", "danger")
      }


    }
    else {


      let Request =
      {
        evbis: selectMachine,
        cliente: selectCliente,
        usuario: stateUser.id
      }


      const consulta = await assignEvbi(dispatch, Request)
      try {

        if (consulta.codigo === "0000") {
          handledAlert("Actualizado Exitosamente!", `Estaciones asignadas con exito para el usuario ${stateUser.name}!`, "success")
          setisOpenModalMachine(false)
        } else {
          handledAlert("Ocurrio un error!", "Ocurrio un error al Asignar las  evbis intente nuevamente", "danger")
        } setisOpenModalMachine(false)

      } catch {
        handledAlert("Ocurrio un erro!", "Error interno", "danger")
      }

    }

  }

  const classes = useStyles();
  const primaryColor = theme.palette.primary.main;

  return (
    <>
      {isOpenModal && <ModalUsers
        setopenMondal={setisOpenModal}
        rowsPerPage={rowsPerPage}
        busqueda={busqueda}
        isOpen={isOpenModal}
        isEdit={isEdit}
        data={dataEdit}

        reload={init}
      />}

      {isOpenModalChangeStatus && <ModalTowButton
        setopenMondal={setisOpenModalChangeStatus}
        isOpen={isOpenModalChangeStatus}
        reload={init}
        title={"Señor usuario"}
        Messange={"¿Esta seguro de cambiar el estado para este usuario?"}
        handledAccept={changeStatus}


      />}

      {isOpenModalRol && <ModalChangeRol
        setopenMondal={setisOpenModalRol}
        isOpen={isOpenModalRol}
        reload={init}
        id={dateChangeRol.id}
      />}

      {isOpenModalChange && <ModalTowButton
        setopenMondal={setisOpenModalChange}
        isOpen={isOpenModalChange}
        reload={init}
        title={"Señor usuario"}
        Messange={"¿Esta seguro de cambiar el Rol para este usuario?"}
        handledAccept={openModalRol}
      />}
      {isOpenModalMachine && <ModalHandledMachine
        setopenMondal={setisOpenModalMachine}
        isOpen={isOpenModalMachine}
        reload={init}
        listClientes={listClientes}
        valuecliente={selectCliente}
        handledChange={handleChangeBasculas}
        handleselectCliente={handleselectCliente}
        value={selectMachine}
        clickCheck={clickAcept}
        stateUser={stateUser}
        setSelectCliente={setSelectCliente}
        setselectMachine={setselectMachine}

      />}
      <Grid item xs={12}>
        <br />
        <br />
        <MigaPan namePage={`Usuarios`}
          namePage2="Administracion"
          to2="/Administracion"
          to="/">
          Home
        </MigaPan>
      </Grid>
      <Paper className={classes.paper} >
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} className={classes.searchContainer} >

              <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: '1%', marginBottom: '2%', textAlign: 'left', marginRight: '75%' }} color='primary'>Usuarios </Typography>

              <Button variant="contained" color="primary" onClick={handledOpenModal}>
                CREAR USUARIO
              </Button>
            </Grid>

            <Table>
              <TableHead color='primary'>
                <TableRow color='primary'>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '7%', width: '20%', color: primaryColor }}>Name</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '15%', color: primaryColor }}>Email</TableCell>
                  <TableCell className={clases.TableCell} style={{ width: '20%', paddingLeft: '12%', color: primaryColor }}>Role</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '9%', width: '15%', color: primaryColor }}>Estado</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '10%', width: '25%', color: primaryColor }}>Acciones</TableCell>

                </TableRow>
              </TableHead>
            </Table>

            <Grid item xs={12}>
              <ListUsersGeneral
                openModalEdit={handledOpenEditModal}
                changeStatus={handledOpenModalState}
                rows={listDate}
                isLoadUser={false}
                page={0}
                size={0}
                totalElement={0}
                setPage={() => { }}
                changeRol={OpenModalInfoChangeRol}
                changeMachine={openModalMachine}
                primaryColor={primaryColor}

              />
            </Grid>
          </Grid>

        </Grid>
      </Paper>
    </>
  );
};